<template>
  <div class="verification-loader">
    <img class="loading loading--bottom" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij4gICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxwYXRoIGZpbGw9IiNGQTYxMjMiIGQ9Ik02NCAzMmMwIDE3LjY3NC0xNC4zMjggMzItMzIuMDAxIDMyUzAgNDkuNjc0IDAgMzIgMTQuMzI2IDAgMzEuOTk5IDAgNjQgMTQuMzI2IDY0IDMyIi8+ICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNNTIuMDYgMzAuNjIzTDQ5LjkzNSAyOC41YTIuMTE4IDIuMTE4IDAgMCAwLTIuOTk2IDBMMzQuOTE2IDQwLjUyMiAzMS4zOTYgMzdhMi4xMTggMi4xMTggMCAwIDAtMi45OTYgMGwtMi4xMjUgMi4xMjNhMi4xMTggMi4xMTggMCAwIDAgMCAyLjk5Nmw3LjE0NCA3LjE0NWMuODI4LjgyOCAyLjE3LjgyOCAyLjk5NiAwTDUyLjA2IDMzLjYyYTIuMTE4IDIuMTE4IDAgMCAwIDAtMi45OTciIG9wYWNpdHk9Ii41NiIvPiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTM4LjE5MiAxNi43NTZsLTIuMTI0LTIuMTI1YTIuMTE4IDIuMTE4IDAgMCAwLTIuOTk3IDBMMjEuMDUgMjYuNjUzbC0zLjUyLTMuNTJhMi4xMTggMi4xMTggMCAwIDAtMi45OTcgMGwtMi4xMjQgMi4xMjJhMi4xMiAyLjEyIDAgMCAwIDAgMi45OThsNy4xNDIgNy4xNDJjLjgyOC44MjggMi4xNy44MjggMi45OTYgMGwxNS42NDYtMTUuNjQzYTIuMTE4IDIuMTE4IDAgMCAwIDAtMi45OTYiLz4gICAgPC9nPjwvc3ZnPg==">
    <img class="loading loading--top" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij4gICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxwYXRoIGZpbGw9IiNGQTYxMjMiIGQ9Ik02NCAzMmMwIDE3LjY3NC0xNC4zMjggMzItMzIuMDAxIDMyUzAgNDkuNjc0IDAgMzIgMTQuMzI2IDAgMzEuOTk5IDAgNjQgMTQuMzI2IDY0IDMyIi8+ICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNNTIuMDYgMzAuNjIzTDQ5LjkzNSAyOC41YTIuMTE4IDIuMTE4IDAgMCAwLTIuOTk2IDBMMzQuOTE2IDQwLjUyMiAzMS4zOTYgMzdhMi4xMTggMi4xMTggMCAwIDAtMi45OTYgMGwtMi4xMjUgMi4xMjNhMi4xMTggMi4xMTggMCAwIDAgMCAyLjk5Nmw3LjE0NCA3LjE0NWMuODI4LjgyOCAyLjE3LjgyOCAyLjk5NiAwTDUyLjA2IDMzLjYyYTIuMTE4IDIuMTE4IDAgMCAwIDAtMi45OTciLz4gICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0zOC4xOTIgMTYuNzU2bC0yLjEyNC0yLjEyNWEyLjExOCAyLjExOCAwIDAgMC0yLjk5NyAwTDIxLjA1IDI2LjY1M2wtMy41Mi0zLjUyYTIuMTE4IDIuMTE4IDAgMCAwLTIuOTk3IDBsLTIuMTI0IDIuMTIyYTIuMTIgMi4xMiAwIDAgMCAwIDIuOTk4bDcuMTQyIDcuMTQyYy44MjguODI4IDIuMTcuODI4IDIuOTk2IDBsMTUuNjQ2LTE1LjY0M2EyLjExOCAyLjExOCAwIDAgMCAwLTIuOTk2IiBvcGFjaXR5PSIuNTYiLz4gICAgPC9nPjwvc3ZnPg==">
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'VerificationLoader',
})
</script>

<style lang="scss">
.verification-loader {
  $size: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 40px 0;

  .loading {
    position: absolute;
    margin: auto;
    width: $size;
    height: $size;
    top: 20px;

    &--top {
      animation-name: fade;
      animation-duration: 0.5s;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
      animation-direction: alternate;
    }

    &--bottom {
      width: $size;
      height: $size;
    }
  }
}
</style>
